import React, { Fragment } from 'react';

import { Paragraph } from 'components/Typography';
import StyledBoldSpan, {
  StyledBox,
  StyledIconWrapper,
  StyledSpan,
} from './Info.styled';

const Info = ({ label, content, hasIcon, icon }) => {
  const renderInfo = (
    <Fragment>
      <StyledBoldSpan>{label}:</StyledBoldSpan>
      <StyledSpan>{content}</StyledSpan>
    </Fragment>
  );

  const renderIcon = hasIcon ? (
    <StyledIconWrapper>{icon}</StyledIconWrapper>
  ) : null;

  return (
    <StyledBox>
      {renderIcon}
      <Paragraph content={renderInfo} pb={1} />
    </StyledBox>
  );
};

export default Info;
